module.exports = __webpack_public_path__ + "img/vodafone-logo.b7dc5c20.png";